module.exports = __webpack_public_path__ + "static/media/pie-chart.37b89186.png";